import ecLogo from "../img/logoEC_azul.svg"

type topBarType = {
  brandLogo?: string,
  brandUrl?: string,
  brandName?: string
}

const ecUrl = "https://www.envioclick.com"

export default function TopBar({ brandLogo, brandUrl, brandName }: topBarType) {

  return (
    <div
      className="px-5 py-2 shadow-md bg-white"
    >
      <a href={brandUrl || ecUrl}>
        <img className="h-12" src={brandLogo || ecLogo} alt={brandName} />
      </a>
    </div>
  )
}